"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Mail32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M28.757 10.071a.5.5 0 11-.514.858l-1.9-1.14a.5.5 0 01.514-.858l1.9 1.14zM17.933 3.577L23.638 7H26.5a.5.5 0 01.5.5v4.816l1-.6V10.5a.5.5 0 111 0v15c0 1.383-1.116 2.5-2.504 2.5H5.504A2.498 2.498 0 013 25.5V10.48c.001-.022.004-.045.008-.068L3 10.5a.501.501 0 01.243-.429L5 9.016V7.5a.5.5 0 01.5-.5h2.88l5.693-3.425c1.083-.65 2.775-.65 3.86.002zM28 12.882l-8.382 5.029 6.736 6.735a.5.5 0 01.057.638l-.057.07a.5.5 0 01-.708 0l-6.911-6.912-.766.46c-1.106.663-2.833.663-3.938 0l-.767-.461-6.912 6.916a.5.5 0 11-.708-.707l6.736-6.74L4 12.884V25.5c0 .832.67 1.5 1.504 1.5h20.992c.835 0 1.504-.669 1.504-1.5V12.882zM26 8H6v4.917l8.545 5.127c.789.473 2.12.474 2.91 0L26 12.916V8zM5 10.182l-1 .6v.935l1 .6v-2.135zm9.589-5.75L10.319 7h11.377l-4.277-2.566c-.769-.46-2.065-.462-2.83-.002z", className: "mail-32_svg__path-1" }))); };
var StyledMail32 = styled_components_1.default(Mail32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledMail32;
var templateObject_1;
//# sourceMappingURL=Mail32.js.map